//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfTabs, SfCheckbox, SfButton, SfLink } from '@storefront-ui/vue';
import { addBasePath, onSSR } from '@vue-storefront/core';
import { useSubscribe, useUser } from '@bee-hole/coms';
import { computed } from '@nuxtjs/composition-api';
export default {
  name: 'MyNewsletter',
  components: {
    SfTabs,
    SfCheckbox,
    SfButton,
    SfLink
  },
  setup() {
    const { unsub, sub, load: subscribeList, info, isSubed } = useSubscribe();
    const { user, load: loadUser } = useUser();
    const subed = computed(() => isSubed.value);
    const subInfo = computed(() => info.value);

    onSSR(async () => {
      await subscribeList();
    });

    const subscribeAdd = async (email) => {
      await sub(email);
      await loadUser();
    };

    const subscribeDel = async () => {
      await unsub();
    };

    return {
      addBasePath,
      subscribeDel,
      subscribeAdd,
      subInfo,
      subed,
      user
    };
  },
  data() {
    return { newsletter: [] };
  }
};
